<template>
  <the-header />
  <navigation />
</template>

<script setup>
import TheHeader from './ui/Header.vue'
import Navigation from './ui/Navigation.vue'
</script>
